import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Hero from '../components/ProgramOverview/Hero'
import Signup from '../components/Shared/Signup'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import Apply from '../components/Apply'
import CustomHelmet from '../components/CustomHelmet'


export default class PressSingle extends Component {
    componentDidMount() {
        window.addEventListener('message', (message) => {
            message.origin === 'https://en.globalcitizenyear.org' ? this.handleDocHeightMsg(message) : null
        });
    }

    setIframeHeightCO = (ht) => {
        var ifrm = document.getElementsByTagName('iframe')[0];

        ifrm.style.visibility = 'hidden';
        // some IE versions need a bit added or scrollbar appears
        ifrm.style.height = ht + "px";
        ifrm.style.visibility = 'visible';
    }


    handleDocHeightMsg = (e) => {
        var data = JSON.parse(e.data)
        this.setIframeHeightCO(data.docHeight)
    }

    render() {
        const { data, location } = this.props
        const post = data.post.edges[0].node
        return (
            <div className="update-single">
                <CustomHelmet data={ post.yoast_data } fallBack={ post } location={ location } />
                <Hero title={ post.title} />
                <Row className="contentWrapper capper">
                    <Column style={{ margin: '0 auto' }} width="9" tablet="12">
                        <div>
                            <p dangerouslySetInnerHTML={{ __html: post.content }} />
                        </div>
                    </Column>
                </Row>
            </div>
        )
    }
}

export const query = graphql`
query Pressquery( $slug: String!) {
  post: allWordpressWpPress(filter: { slug: {eq: $slug}}) {
    edges {
      node {
        slug
        title
        date
        content
        featured_media
        yoast_data {
          pageTitle
          pageDescription
          opengraphTitle
          opengraphDescription
        }
      }
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/templates/press-single.js